import { useEffect } from 'react';

/**
 * CardModal - カード画像を拡大表示するモーダル
 *
 * @param {{ imageSrc: string, altText: string, onClose: () => void }} props
 */
const CardModal = ({ imageSrc, altText, onClose }) => {
  // 背景スクロールを止める
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  // ESCキーで閉じる
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
      onClick={onClose}
    >
      {/* モーダル本体：クリックが親に伝播しないようにする */}
      <div
        className="relative max-w-[90vw] max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageSrc}
          alt={altText}
          className="max-w-full max-h-[85vh] object-contain rounded-lg drop-shadow-2xl"
        />
        {/* 閉じるボタン */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-white text-gray-800 font-bold text-lg flex items-center justify-center shadow-lg"
          aria-label="閉じる"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default CardModal;
